import { Filters } from "./filters";
import { Summary } from "./summary";
import { Columns } from "./columns";
import { ReportConfigBase } from "../index";
import { EReportTypes } from "../../routes/report_types";

const FinanceSalesOrdersReportConfig: ReportConfigBase = {
  type: EReportTypes.FinanceSalesOrders,
  endpoint: "report/finance-sales-orders",
  filtersBase: Filters,
  summaryBase: Summary,
  columnsBase: Columns,
  withSelection: false,
  intro: {
    description:
      "Sales Orders",
    url: "https://help.commonsku.com/knowledge/new-client-invoicing-report",
  },
};

export default FinanceSalesOrdersReportConfig;
